import Vue from 'vue'
import axios from 'axios'
// import $modal from './modal'
import { Loading, Message } from 'element-ui'


let downloadLoadingInstance;
// 获取config.js中配置的请求地址
let config = JSON.parse(localStorage.dynamicConfig);
let {baseUrl, devApi} = config;
// let baseUrl = ''

const whitePath = ['/login', '/getCode']


// 创建axios实例
const service = axios.create({
	// baseURL: baseUrl,
	timeout: 60 * 1000 // 请求超时
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		return config
	},
	error => {
		// 处理请求错误
		console.log("request Err", error) // for debug
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		// 如果状态码不是200，则判断为错误.
		if ( res.code !== 200 ) {
			Message.error(res.msg || '未知错误')
			// $modal.msgError( res.msg || '未知错误');
			return Promise.reject(new Error(res.msg || 'Error'))
		} else {
			return res
		}
	},
	error => {
		const res = error.response.data;
		Message.error(res.msg || '未知错误')
		// $modal.msgError( res.msg || '未知错误');
		console.log("response Err", error.response.data) // for debug
		return false
	}
)


// GET请求
function get(url, data) {
	return service.get(url, {
		params: data || {}
	});
}

// POST请求
function post(url, data) {
	return service.post(url, data || {});
}

// PostFormData请求
function postFormData(url, data) {
	let formData = new FormData();
	for (let k in data) {
		formData.append(k, data[k]);
	}
	return service.post(url, formData);
}

// 上传文件
function uploadFile(url, file) {
	let formData = new FormData();
	formData.append("file", file);
	return service.post(url, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		responseType: "blob"
	});
}

console.log( process.env.NODE_ENV )

//封装http请求
const http = {
	get,
	post,
	postFormData,
	uploadFile,
	baseUrl: process.env.NODE_ENV === "development" ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API,
	fileUrl: process.env.VUE_APP_BASE_URL,
}

export default http

